import { matchPath } from 'react-router-dom';

import { type SystemNotification } from '../types';

/**
 * Checks if a notification matches the current route based on its targeting configuration
 */
export function doesNotificationMatchRoute(
  notification: SystemNotification,
  currentPath: string,
): boolean {
  if (notification.targeting.scope === 'global') return true;

  const routes = notification.targeting.routes ?? [];
  return routes.some(pattern => matchPath(pattern, currentPath) !== null);
}
